import { MinIOFile } from 'components/FileInput/types';

export type RatingType = 'partner' | 'personal' | 'partner-ugo';

export enum ECriteriaRatingType {
  Boolean = 'bool',
  Mark = 'mark',
}

export interface IRatingNotification {
  show: boolean;
  partners: IRatingNotificationOf<IPartnerRating>;
  personal: IRatingNotificationOf<IPersonalRating>;
  defectActUgo: IRatingNotificationOf<IPartnerUgoRating>;
}

interface IRatingNotificationOf<List> {
  required: boolean;
  message: string;
  list: List[];
}

// Партнеры
export interface IPartnerRating {
  ratingOvks?: number;
  ratingNegativeOvks?: number;
  ratingApplication?: number;
  ratingPositive?: number;
  ratingPartner?: number;
  roomCount?: number | null;
  realEstatePartnerRatingId?: number;
  realEstatePartnerId?: number;
  dateAt?: string;
  criteriaRatings?: ICriteriaRating[];
  criteriaRatingSum?: number;
  partnerGuid?: string;
  partnerName?: string;
  serviceTypeId?: number;
  serviceTypeName?: string;
  realEstateGuid?: string;
  realEstateName?: string;
  contractEnd?: string | null;
  positionId?: number;
  positionName?: string;
  ratingBy?: string | null;
  ratingAt?: string | null;
}

// Персонал
export interface IPersonalRating {
  realEstatePersonalId?: number;
  personalId?: number;
  firstName?: string;
  lastName?: string;
  birthDate?: string;
  fullName?: string;
  email?: string;
  phone?: string;
  realEstateGuid?: string;
  realEstateName?: string;
  serviceTypeId?: number;
  serviceTypeName?: string;
  partnerGuid?: string;
  partnerName?: string;
  positionId?: number;
  positionName?: string;
  ratingSum?: number;
  realEstatePersonalRatingId?: number;
  rating?: number;
  dateAt?: string;
}

export interface IPersonalRatingRequest {
  realEstatePersonalRatingId: number;
  rating: number | null;
  skipped: boolean;
  comment: string | null;
}

// Партнеры УГО
export interface IPartnerUgoRating {
  defectActRatingUgoId?: number;
  applicationNumber?: string;
  nomenclaturaName?: string;
  nomenclaturaGuid?: string;
  ratingAt?: string;
  smrPartnerGuid?: string;
  smrPartnerName?: string;
  downloadFileInfo?: MinIOFile;
  criteriaRatings?: Pick<ICriteriaRating, 'criteriaRatingId' | 'criteriaRatingName' | 'value'>[];
}

// Остальные интерфейсы
export interface IUpdateRatingNotification {
  realEstatePartnerRatingIds: number[];
  realEstatePersonalRatingIds: number[];
}

export interface ICriteriaRating {
  criteriaRatingId: number;
  criteriaRatingName: string;
  ratingTrue: number;
  ratingFalse: number;
  value: number | null;
  type: ECriteriaRatingType;
}

export interface IRealEstate {
  realEstateGuid?: string;
  realEstateName?: string;
}

export interface IPartner {
  partnerGuid?: string;
  partnerName?: string;
}
